// @ts-nocheck
const isArray = (val) => Array.isArray(val)

const isObject = (val) => typeof val === 'object' && val !== null

export const deepFindValues = (obj, target, state = []) =>
  Object.values(obj).reduce((acc, val) => {
    if (isArray(val)) val.map((v) => isObject(v) && deepFindValues(v, target, acc))
    if (isObject(val))
      return target in val ? [...acc, val[target]] : deepFindValues(val, target, acc)
    return acc
  }, state)

export const set = (obj, path, value) => {
  const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])/g)

  pathArray.reduce((acc, key, i) => {
    if (acc[key] === undefined) acc[key] = {}
    if (i === pathArray.length - 1) acc[key] = value
    return acc[key]
  }, obj)
}
